// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { ILetterOfMedicalNecessityResponse } from './ILetterOfMedicalNecessityResponse';
import {
    ILetterOfMedicalNecessityResponseFromJSON,
    ILetterOfMedicalNecessityResponseFromJSONTyped,
    ILetterOfMedicalNecessityResponseToJSON,
    ILetterOfMedicalNecessityResponseToJSONTyped,
} from './ILetterOfMedicalNecessityResponse';

/**
 * 
 * @export
 * @interface ICustomPageLetterOfMedicalNecessityResponse
 */
export interface ICustomPageLetterOfMedicalNecessityResponse {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<ILetterOfMedicalNecessityResponse>}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    content?: Array<ILetterOfMedicalNecessityResponse>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageLetterOfMedicalNecessityResponse
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageLetterOfMedicalNecessityResponse interface.
 */
export function instanceOfICustomPageLetterOfMedicalNecessityResponse(value: object): value is ICustomPageLetterOfMedicalNecessityResponse {
    return true;
}

export function ICustomPageLetterOfMedicalNecessityResponseFromJSON(json: any): ICustomPageLetterOfMedicalNecessityResponse {
    return ICustomPageLetterOfMedicalNecessityResponseFromJSONTyped(json, false);
}

export function ICustomPageLetterOfMedicalNecessityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageLetterOfMedicalNecessityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ILetterOfMedicalNecessityResponseFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageLetterOfMedicalNecessityResponseToJSON(json: any): ICustomPageLetterOfMedicalNecessityResponse {
    return ICustomPageLetterOfMedicalNecessityResponseToJSONTyped(json, false);
}

export function ICustomPageLetterOfMedicalNecessityResponseToJSONTyped(value?: ICustomPageLetterOfMedicalNecessityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ILetterOfMedicalNecessityResponseToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

